export default "<svg viewBox=\"0 0 24 24\">\r\n  <path d=\"M24 6H0V2h24v4zm0 4H0v4h24v-4zm0 8H0v4h24v-4z\"/>\r\n</svg>\r\n";